import app from "antd/es/app";
import userUtils from "../manager/userUtils";
import rm from "./rm";
import api from "./api";

export const uploadBase64Image = async (base64: string) => {
    return uploadImageFile(base64)
}

export const uploadImageFile = async (base64OrFile: string | File) => {
    return new Promise<{
        success: boolean;
        url: string | null;
        width: number;
        newFormats: string | null;
        height: number;
        message: string
    }>((resolve) => {
        const fd = new FormData();
        const imgFile = typeof base64OrFile === "string" ? convertBase64UrlToBlob(base64OrFile) : base64OrFile;
        let fileName = "image";
        if (typeof base64OrFile === "string") {
            fileName = 'image.' + base64OrFile.split(';')[0].substring('data:image/'.length);
        } else {
            fileName = base64OrFile.name;
        }
        
        fd.append('upfile', imgFile);
        fd.append("filename", fileName)
        fd.append('name', 'image');
        fd.append('appver', `${rm.getSystemInfoSync().systemInfo?.appVer}`);
        fd.append('platform', userUtils.getPlaform().platform);
        fd.append('userhash', `${userUtils.getUserHash()}`);
        const xhr = new XMLHttpRequest();
        const headers: any = {
            "appver": rm.getSystemInfoSync().systemInfo?.appVer,
            ...userUtils.getPlaform(),
            "userhash": userUtils.getUserHash(),
        };
        xhr.open('post', api.get("uploadpicture", { useType: 1 }), true);
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        for (const key in headers) {
            xhr.setRequestHeader(key, headers[key]);
        }
        xhr.addEventListener('load', function (e: any) {
            try {
                const json = JSON.parse(e.target ? e.target['response'] : '{}');
                let link = json.url || (json.content && json.content.img) || json.data;
                let width = json.width || 0;
                let height = json.height || 0;
                let newFormats = json.newFormats || 0;
                if (typeof link === 'object') {
                    link = link.url;
                }
                resolve({
                    success: true,
                    url: link,
                    width,
                    height,
                    newFormats,
                    message: '上传成功'
                });
            } catch (er: any) {
                resolve({
                    success: true,
                    url: null,
                    width: 0,
                    height: 0,
                    newFormats: null,
                    message: er && er.message ? er.message : '图片上传失败',
                });
            }
        });
        xhr.addEventListener('error', function (er: any) {
            resolve({
                success: true,
                url: null,
                width: 0,
                height: 0,
                newFormats: null,
                message: er && er.message ? er.message : '图片上传失败',
            });
        });
        xhr.send(fd);
    });
};

function convertBase64UrlToBlob(urlData: string) {
    const bytes = window.atob(urlData.split(',')[1]); //去掉url的头，并转换为byte
    //处理异常,将ascii码小于0的转换为大于0
    const ab = new ArrayBuffer(bytes.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
    }
    return new Blob([ab], { type: urlData.split(';')[0].substring('data:'.length) });
}